import { render, staticRenderFns } from "./ContestSubscribeForm.vue?vue&type=template&id=b96328ce"
import script from "./ContestSubscribeForm.vue?vue&type=script&lang=js"
export * from "./ContestSubscribeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports